import React from "react";
import Dialog from "sushiweb/Dialog";

//always send required prop permissions as true, if the acceptButton is not permission based

const AnimatedDialog = (props) => {
  const {
    isVisible,
    handleAccept,
    handleReject,
    acceptLabel,
    rejectLabel,
    header,
    heading,
    subHeading,
    permission,
    id,
  } = props;
  return (
    <div className="dialog-container">
      <Dialog
        visible={isVisible}
        acceptLabel={permission ? acceptLabel : ""}
        rejectLabel={rejectLabel}
        onAccept={permission ? handleAccept : null}
        onReject={handleReject}
        onClose={handleReject} //onBlur event, when user clicks outside of dialog
        slideOnMobile={true}
        className="animated-dialog"
        id={id}
      >
        {header && (
          <div className="dialog-header">
            <h2 className="heading">{heading}</h2>
            <p className="subHeading">{subHeading}</p>
          </div>
        )}
        {props.children}
      </Dialog>
    </div>
  );
};

export default AnimatedDialog;
